<template>
  <v-container text-xs-center>
    <v-data-table
      :headers="headers"
      :items="meetsItems"
      :search="search"
      :class="{ mobile: isMobile }"
      class="elevation-3"
      group-key="set_lib_set_id"
      item-key="node.meetId"
      :expanded.sync="expanded"
      show-expand
      :page.sync="page"
      :loading="loading"
      loading-text="Loading, please wait..."
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      sort-by="node.meetDate"
      sort-desc
    >
      <template v-slot:top>
        <BaseToolbar toolbarTitle="Meets">
          <template v-slot:toolbarSearch>
            <v-layout row wrap class="mt-1">
              <DateRange
                v-on:change-fromDate="onChangeFromDate"
                v-on:change-toDate="onChangeToDate"
              />
            </v-layout>
          </template>
          <template v-slot:toolbarBtn>
            <v-dialog
              v-model="dialog"
              max-width="700px"
              :retain-focus="false"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-on="on" v-bind="attrs">{{
                  formTitle
                }}</v-btn>
              </template>
            </v-dialog>
          </template>
        </BaseToolbar>
      </template>
      <!--TABLE ACTIONS SECION-->
      <template #[`item.action`]="{ item }">
        <v-icon small class="mr-2" @click="edit(item.node)"> edit </v-icon>
        <v-icon small @click="deleteMeet(item.node.meetId)"> delete </v-icon>
      </template>
      <!--EXPANDED TEMPALTE-->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-5">
          <v-expansion-panels>
            <v-expansion-panel>
              <h3 class="header_session">Meet Sessions</h3>
              <div class="session_wrapper">
                {{ item.node.meetDesc }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="green"
                      x-large
                      class="mr-2 ml-5"
                      v-bind="attrs"
                      v-on="on"
                      @click="addSession(item.node.meetId)"
                    >
                      add
                    </v-icon>
                  </template>
                  <span>Add Session</span>
                </v-tooltip>
                <v-dialog
                  v-model="dialogSession"
                  :retain-focus="false"
                  max-width="700px"
                  persistent
                >
                  <sessionForm
                    :meetId="item.node.meetId"
                    @close-form="closeSession"
                    @set-loading="loading = $event"
                  ></sessionForm>
                </v-dialog>
                <MeetSessions :meetId="item.node.meetId"></MeetSessions>
              </div>
            </v-expansion-panel>
          </v-expansion-panels>
          <div
            class="pt-3"
            v-if="
              item.node.tag && item.node.tag.length > 0 && isJson(item.node.tag)
            "
          >
            <v-chip-group show-arrows>
              <v-chip
                v-for="(chip, indx) in JSON.parse(item.node.tag)"
                :key="indx"
                text-color="white"
                small
                class="p-2"
                color="light-blue darken-4"
              >
                {{ chip }}
              </v-chip>
            </v-chip-group>
          </div>
        </td>
      </template>
    </v-data-table>
    <!--DIALOG SECTION-->
    <v-dialog
      v-model="dialog"
      :retain-focus="false"
      max-width="700px"
      persistent
    >
      <meetForm
        :formTitle="formTitle"
        :index="editedIndex"
        :editData="dataToEdit"
        @close-form="close"
        @set-loading="loading = $event"
      ></meetForm>
    </v-dialog>
    <!--PAGINATION-->
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        color="light-blue darken-4"
        :length="pageCount"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
//TODO Fix dataRange component problems
import { mapGetters, mapActions } from "vuex";
import DateRange from "../shared/date_range_from_to.vue";
import meetForm from "../forms/meetForm.vue";
import sessionForm from "../forms/meetSessionForm.vue";
import { meetHeaders } from "@/constants/tabelsData";
import { validationRules } from "@/constants/global";
import { hasJsonStructure } from "@/_helpers/index";
import BaseToolbar from "../base/BaseToolbar.vue";
import MeetSessions from "..//libs/meetSession/meetSessions.vue";
import EventsList from "../libs/meetSession/eventsList.vue";
export default {
  components: {
    DateRange,
    meetForm,
    BaseToolbar,
    sessionForm,
    MeetSessions,
    EventsList
  },
  data() {
    return {
      page: 1,
      loading: true,
      expanded: [],
      formValid: true,
      dataToEdit: false,
      pageCount: 0,
      dialog: false,
      dialogSession: false,
      itemsPerPage: 10,
      nameRules: validationRules.name,
      requiredRule: validationRules.required,
      tabs: 0,
      search: "",
      editedIndex: -1,
      fromDate: new Date(new Date().setDate(new Date().getDate() - 730))
        .toISOString()
        .substr(0, 10),
      toDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 6,
        new Date().getDate()
      )
        .toISOString()
        .substr(0, 10),
      isMobile: false,
      headers: meetHeaders
    };
  },
  async created() {
    await this.$store
      .dispatch("allMeets")
      .then(() => (this.loading = false))
      .catch(error => {
        console.error(error);
        this.loading = false;
      });

    if (!(Object.entries(this.$route.query).length === 0)) {
      const { fromDate, toDate } = this.$route.query;
      //assign to current instance variables
      console.log(this.toDate);
      this.fromDate = fromDate;
      this.toDate = toDate;
    }
    await this.$store
      .dispatch("allMeetSession")
      .then(() => (this.loading = false))
      .catch(error => {
        console.error(error);
        this.loading = false;
      });
    await this.$store
      .dispatch("allEvents")
      .then(() => (this.loading = false))
      .catch(error => {
        console.error(error);
        this.loading = false;
      });
    await this.$store
      .dispatch("allMeetEvent")
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    ...mapActions(["deleteCurrentMeet"]),
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    /**
     * @param item
     */
    isJson(item) {
      return hasJsonStructure(item);
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;
    },
    closeSession() {
      this.dialogSession = false;
    },
    deleteMeet(id) {
      this.loading = true;
      this.deleteCurrentMeet({
        meetId: parseInt(id, 10)
      })
        .then(() => {
          this.loading = false;
          this.$toast.error("Meet has been deleted");
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    edit(item) {
      this.dataToEdit = Object.assign({}, item);
      this.dialog = true;
      this.editedIndex = 1;
    },
    addSession(meetId) {
      this.dialogSession = true;
    },
    handleGetMeetsLib() {
      //reach out of Vuex store, fire action that gets posts for carousel
      this.$store.dispatch("allMeets");
    },
    someFun() {
      return true;
    },
    /**
     * @param {String || Number || NULL || Boolean}
     * @return {String || Number || Boolean}
     */
    dataIsValid(item) {
      switch (typeof item) {
        case "string":
          return item.length > 0 ? item : false;
        case "number":
          return item;
        case "boolean":
          return item ? true : false;
        default:
          return false;
      }
    },
    /**
     * @param {Date}
     * @return {Boolean}
     */
    dateCheck(from, to, check) {
      var fDate, lDate, cDate;
      fDate = Date.parse(from);
      lDate = Date.parse(to);
      cDate = Date.parse(check);

      if (cDate <= lDate && cDate >= fDate) {
        return true;
      }
      return false;
    },
    updateRouterQuery() {
      this.$router.replace({
        query: { fromDate: this.fromDate, toDate: this.toDate }
      });
    },
    onChangeFromDate(value) {
      this.fromDate = value;
      this.updateRouterQuery();
    },
    onChangeToDate(value) {
      this.toDate = value;
      this.updateRouterQuery();
    }
  },
  computed: {
    ...mapGetters(["meets"]),
    /**
     * @return {String}
     */
    formTitle() {
      return this.editedIndex === -1 ? "New meet" : "Edit meet";
    },
    /**
     * @return {Function}
     */
    actionName() {
      return this.editedIndex === -1 ? this.addNewMeet : this.editMeet;
    },

    /**
     * @param {Array[Object]}
     * @return {Array[] || Array[Object]}
     */
    meetsItems() {
      if (this.meets.edges) {
        return this.meets.edges.filter(item =>
          this.dateCheck(this.fromDate, this.toDate, item.node.meetDate)
        );
      } else {
        return [];
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  }
};
</script>
<style scoped>
.v-expansion-panel-content__wrap {
  display: flex;
  flex-direction: row;
}
.session_wrapper {
  padding: 5px;
}
.header_session {
  margin: 5px;
}
</style>
